import { MapPin, Navigation, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";

export const directionUrls = (lat, lng) => lat != null && lng != null ? {
  maps: `https://www.google.com/maps?q=${lat},${lng}`,
  waze: `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`,
} : null;

export function StudentAddressPreview({ a, testId = "student-preview" }) {
  const urls = directionUrls(a.lat, a.lng);
  const place = [a.address, a.commune].filter(Boolean).join(", ");
  return (
    <div className="rounded-2xl border-2 border-dashed border-primary/30 p-3 space-y-3" data-testid={testId}>
      <p className="text-xs font-semibold text-primary flex items-center gap-1.5"><Eye className="w-3.5 h-3.5" />Así lo verá tu alumno en su ticket</p>
      <div className="rounded-xl bg-card border p-3 space-y-3 shadow-sm">
        <div className="flex gap-2.5">
          <MapPin className="w-4 h-4 mt-0.5 text-primary shrink-0" />
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Lugar</p>
            <div className="text-sm font-semibold break-words" data-testid={`${testId}-address`}>
              {a.label && <span className="block text-primary">{a.label}</span>}
              {place || "—"}
              {a.address_reference && <span className="block text-xs text-muted-foreground font-normal">{a.address_reference}</span>}
            </div>
          </div>
        </div>
        {urls ? (
          <div className="grid grid-cols-2 gap-2">
            <Button asChild size="sm"><a href={urls.maps} target="_blank" rel="noreferrer" data-testid={`${testId}-maps`}><Navigation className="w-4 h-4 mr-1" />Google Maps</a></Button>
            <Button asChild size="sm" variant="secondary"><a href={urls.waze} target="_blank" rel="noreferrer" data-testid={`${testId}-waze`}><Navigation className="w-4 h-4 mr-1" />Waze</a></Button>
          </div>
        ) : (
          <p className="text-xs text-amber-700" data-testid={`${testId}-nomap`}>Sin pin confirmado: tus alumnos no verán los botones de Google Maps y Waze.</p>
        )}
      </div>
      {urls && <p className="text-[11px] text-muted-foreground">Prueba los botones: se abrirán con la ubicación exacta de tu pin.</p>}
    </div>
  );
}
